const normalize = (value) => String(value || '').toLowerCase();

/**
 * The catalog apps that match a search, best matches first: name starts with the query, then name
 * contains it, then an alias or the description does. Without a query, every app by name.
 */
const filterCatalogApps = ({ apps, query }) => {
  const needle = normalize(query).trim();
  const byName = [...apps].sort((left, right) => normalize(left?.name).localeCompare(normalize(right?.name)));

  if (!needle) {
    return byName;
  }

  const rank = (app) => {
    const name = normalize(app?.name);
    if (name.startsWith(needle)) {
      return 0;
    }
    if (name.includes(needle)) {
      return 1;
    }
    const aliases = Array.isArray(app?.aliases) ? app.aliases.map(normalize) : [];
    if (aliases.some((alias) => alias.includes(needle))) {
      return 2;
    }
    return normalize(app?.description).includes(needle) ? 3 : null;
  };

  return byName
    .map((app) => ({ app, score: rank(app) }))
    .filter((entry) => entry.score !== null)
    .sort((left, right) => left.score - right.score)
    .map((entry) => entry.app);
};

export default filterCatalogApps;
